import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { IdNameApiModel, PhaseApiModel, PhaseUsageApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { sanitizeHtml } from '@shared/utils/editor-utils';

@Injectable()
export class PhasesService extends CrudService<PhaseApiModel, number> {
  public apiUrl = 'phases';

  constructor(public http: HttpClientService) {
    super(http);
  }

  public getShortList(): Observable<Array<IdNameApiModel>> {
    return this.http.get<Array<IdNameApiModel>>(`${this.apiUrl}/get-short-list`);
  }

  public add(model: PhaseApiModel): Observable<PhaseApiModel> {
    model.Description = sanitizeHtml(model.Description);
    return super.add(model);
  }

  public update(model: PhaseApiModel): Observable<PhaseApiModel> {
    model.Description = sanitizeHtml(model.Description);
    return super.update(model);
  }

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }

  public getFormInstances(phase: PhaseApiModel): Observable<Array<PhaseUsageApiModel>> {
    return this.http.get<Array<PhaseUsageApiModel>>(`${this.apiUrl}/${phase.Id}/form-instances`);
  }
}
